import { forwardRef } from 'react';
import {
  Button,
  CircularProgress,
} from '@mui/material';
import { filterUndefined } from '../../utils/FilterUndefinedObject';
import './ButtonWithSpinner.scss';

/**
 * Button component that its label can change to spinning icon when
 * it is loading
 *
 * Props:
 * label - Required : Label of the button when it is not displaying spinning icon
 * loading - Required: Whether the button is showing the spinning icon
 * className: class name
 * size: size of spinning icon
 */
const defaultProps = {
  className: '',
  size: 25,
  loading: false,
  variant: 'contained',
  buttonClass: 'btn-primary',
};

const ButtonWithSpinner = forwardRef((props, ref) => {
  const {
    className,
    label,
    loading,
    size,
    variant,
    buttonClass,
    ...rest
  } = { ...defaultProps, ...filterUndefined(props) };
  const { onClick, ...restNoOnClick } = rest;
  return (
    loading
      ? (
        <Button {...restNoOnClick} variant={variant} className={`btn-primary button-with-spinner ${className}`}>
          <CircularProgress size={size} className='btn-spinning' />
        </Button>
      ) : (
        <Button
          ref={ref}
          variant={variant}
          className={`${buttonClass}
          button-with-spinner ${className}`}
          onKeyDown={(e) => {
            if (!onClick) {
              return;
            }
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              e.stopPropagation();
              onClick(e);
            }
          }}
          {...rest}
        >
          {label}
        </Button>
      )
  );
});

export default ButtonWithSpinner;
